import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./profile";

export default configureStore({
  reducer: {
    user: userReducer,
  },
});
